var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownNarrow = function SvgArrowDownNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.814 16.186c.449.45.449 1.178 0 1.628l-4 4a1.2 1.2 0 0 1-.272.2 1.1 1.1 0 0 1-.32.114 1.2 1.2 0 0 1-.338.017 1.1 1.1 0 0 1-.266-.062 1 1 0 0 1-.16-.07q-.02-.011-.041-.024a1.2 1.2 0 0 1-.23-.175l-4-4a1.15 1.15 0 0 1 1.626-1.628l1.695 1.695a.2.2 0 0 0 .342-.141V3a1.15 1.15 0 0 1 2.3 0v14.74a.2.2 0 0 0 .342.141l1.694-1.695a1.15 1.15 0 0 1 1.628 0"
  })));
};
export default SvgArrowDownNarrow;